import info from '@/components/brand/info/storage';
import list from '@/components/brand/list/storage';
import semantics from '@/components/brand/semantics/storage';
import semanticst from '@/components/brand/semanticst/storage';
import products from '@/components/brand/products/storage';
import country from '@/components/brand/country/storage';
import dynamics from '@/components/brand/dynamics/storage';
import position from '@/components/brand/position/storage';


export default {
    namespaced: true,
    modules: {
        info,
        list,
        semantics,
        semanticst,
        products,
        country,
        dynamics,
        position,
    },
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}